import { Box, styled } from '@mui/material';

import type { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';

export const ShareUserButtonContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['size', 'isUsersListWithOwner'].includes(prop),
})<{ size: AvatarSizeEnum; isUsersListWithOwner: boolean }>(({ theme, size, isUsersListWithOwner }) => ({
  cursor: 'pointer',
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `0.75px dashed ${theme.palette.case.neutral.n500}`,
  backgroundColor: theme.palette.case.neutral.n0,
  marginLeft: isUsersListWithOwner ? '8px' : '0px',

  svg: {
    height: '16px',
    width: '16px',
  },
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n100,
  },
  '&:active': {
    backgroundColor: theme.palette.case.neutral.n200,
  },
}));
